export default function relValue() {
  return 'sponsored nofollow'
}
